<template>
    <div class="employeeListing__vueParent">
        <transition name="fade">
            <div v-if="modalIsOpen"
                 class="employeeModal"
                 :class="[`employeeModal--${currentModalData.colour}`]"
                 @click.prevent="modalCloseEvent"
            >
                <transition name="fade">
                    <div v-if="modalIsVisible && Object.keys(currentModalData).length > 0"
                         class="employeeModal__inner"
                         @click.prevent="modalCloseEvent"
                    >
                        <div class="employeeModal__content"
                             @click.stop.prevent
                        >
                            <button class="employeeModal__closeButton"
                                    title="Close Modal"
                                    @click.prevent="modalCloseEvent"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.46584 8.00012L15.6959 1.76972C16.1014 1.36446 16.1014 0.709208 15.6959 0.303946C15.2907 -0.101315 14.6354 -0.101315 14.2302 0.303946L7.99991 6.53434L1.76983 0.303946C1.36438 -0.101315 0.709335 -0.101315 0.304082 0.303946C-0.101361 0.709208 -0.101361 1.36446 0.304082 1.76972L6.53416 8.00012L0.304082 14.2305C-0.101361 14.6358 -0.101361 15.291 0.304082 15.6963C0.506044 15.8984 0.771594 16 1.03695 16C1.30231 16 1.56767 15.8984 1.76983 15.6963L7.99991 9.46589L14.2302 15.6963C14.4323 15.8984 14.6977 16 14.963 16C15.2284 16 15.4938 15.8984 15.6959 15.6963C16.1014 15.291 16.1014 14.6358 15.6959 14.2305L9.46584 8.00012Z" fill="currentColor"/>
                                </svg>
                            </button>

                            <div class="employeeModal__image">
                                <div class="employeeModal__imageInner">
                                    <StaffStampImage
                                        class-name="employeeModal__imageImage"
                                        :colour="currentModalData.colour"
                                        :img="currentModalData.img_small"
                                        :name="currentModalData.name"
                                    />

                                    <div class="employeeModal__imageText">
                                        <p class="employeeModal__imageName">{{ currentModalData.name }}</p>

                                        <p class="employeeModal__imageJobTitle">{{ currentModalData.job_title }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="employeeModal__text">
                                <p class="employeeModal__description">{{ currentModalData.description }}</p>

                                <p class="employeeModal__handwritten">{{ currentModalData.handwritten }}</p>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>

        <div class="employeeListing__container">
            <div class="employeeListing__bg">
                <div class="employeeListing__innerContainer">
                    <div class="employeeListing__list">
                        <template v-if="employees && employees.length > 0">
                            <button v-for="(employee, i) in employees"
                                    :key="i"
                                    class="employeeModalButton"
                                    :class="[employee.colour ? `employeeModalButton--${employee.colour}` : '']"
                                    @click.prevent="buttonClickEvent(i)"
                                    data-aos="fade-up"
                                    data-aos-easing="ease-in-sine"
                                    data-aos-duration="600"
                                    data-aos-offset="200"
                                    data-aos-delay="125"
                            >
                                <StaffStampImage
                                    class-name="employeeModalButton__image"
                                    :colour="employee.colour"
                                    :img="employee.img_small"
                                    :name="employee.name"
                                />

                                <div class="employeeModalButton__text">
                                    <p class="employeeModalButton__name">{{ employee.name }}</p>

                                    <p class="employeeModalButton__jobTitle">{{ employee.job_title }}</p>
                                </div>
                            </button>
                        </template>

                        <p v-else
                           class="employeeListing__emptyMessage"
                        >There are no employees at this time.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import StaffStampImage from './staff_stamp_image.vue'

export default defineComponent({
    props: {
        employees: {
            type: Array,
            default() {
                return [];
            }
        },
        theme: {
            type: String,
            default: ""
        },
    },
    components: {
        StaffStampImage
    },
    data() {
        return {
            modalIsOpen: false,
            modalIsVisible: false,
            currentModalData: {},
            canClick: true,
            windowResize: null
        }
    },
    methods: {
        buttonClickEvent(index) {
            if (this.canClick === true) {
                document.documentElement.classList.add('noScroll');
                this.canClick = false;
                this.currentModalData = Object.assign({}, this.employees[index]);
                this.modalIsOpen = true;
                setTimeout(() => {
                    this.modalIsVisible = true;
                }, 500);
            }
        },
        modalCloseEvent() {
            this.modalIsVisible = false;
            setTimeout(() => {
                this.modalIsOpen = false;
                setTimeout(() => {
                    this.currentModalData = Object.assign({}, {});
                    document.documentElement.classList.remove('noScroll');
                }, 500);
                setTimeout(() => {
                    this.canClick = true;
                }, 1500);
            }, 500);
        }
    },
    mounted() {
        window.onresize = () => {
            clearTimeout(this.windowResize);
            this.windowResize = setTimeout(this.modalCloseEvent, 100);
        };
    }
});
</script>
